var AdaptiveImage = require("../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/data_security_badge.8ec337a6.png","uri@2x": __webpack_public_path__ + "static/media/data_security_badge.63cd3072.png","uri@3x": __webpack_public_path__ + "static/media/data_security_badge.4aab807d.png",
    width: 162,
    height: 46
});